import React, { useEffect, useState } from 'react';
import { getApiUrl } from '../../utils/api';
import { useNotification } from '../../contexts/NotificationContext';

const NewFolderModal = ({ isOpen, onClose, onSuccess, parentFolder = null, defaultProjectId = '', scope = 'cases' }) => {
  const { showError, showSuccess } = useNotification();
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [projectId, setProjectId] = useState('');
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    const fetchProjects = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await fetch(getApiUrl('projects'), {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (res.ok) {
          const data = await res.json();
          const list = Array.isArray(data?.projects) ? data.projects : (Array.isArray(data) ? data : []);
          setProjects(list);
          // Herdar projeto da pasta pai quando houver contexto
          if (parentFolder?.project_id) {
            setProjectId(String(parentFolder.project_id));
          } else if (defaultProjectId) {
            setProjectId(String(defaultProjectId));
          } else if (!projectId && list.length > 0) {
            setProjectId(String(list[0].id));
          }
        } else {
          showError('Erro ao carregar projetos');
        }
      } catch (err) {
        console.error('Erro ao buscar projetos:', err);
        showError('Erro ao carregar projetos');
      }
    };
    fetchProjects();
  }, [isOpen, parentFolder, defaultProjectId, showError]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      showError('Nome da pasta é obrigatório');
      return;
    }
    if (!projectId) {
      showError('Selecione um projeto');
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(getApiUrl('test-repository/folders'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          name: name.trim(),
          description: description || null,
          parent_folder_id: parentFolder?.id || null,
          // Enviar UUID do projeto como string (sem conversão numérica)
          project_id: projectId,
          scope: (scope || 'cases')
        })
      });

      if (res.ok) {
        let data = null;
        try {
          data = await res.json();
        } catch (_) {
          // Backend pode responder 201 sem corpo em alguns ambientes; tratar como sucesso
          data = null;
        }
        showSuccess('Pasta criada com sucesso');
        onSuccess && onSuccess(data);
        handleClose();
      } else {
        const errData = await res.json().catch(() => ({}));
        showError(errData.error || 'Erro ao criar pasta');
      }
    } catch (err) {
      console.error('Erro ao criar pasta:', err);
      showError('Erro ao criar pasta');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setName('');
    setDescription('');
    onClose && onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-header">
          <h2>Nova Pasta</h2>
          <button className="modal-close" onClick={handleClose}>✕</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-group">
              <label>Projeto</label>
              <select value={projectId} onChange={(e) => setProjectId(e.target.value)} disabled={!!parentFolder}>
                {projects.map(p => (
                  <option key={p.id} value={p.id}>{p.name}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Pasta pai</label>
              <input type="text" value={parentFolder ? parentFolder.name : 'MAIN'} disabled />
            </div>
            <div className="form-group">
              <label>Nome *</label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Ex.: Login Flow, Cart, Payment"
                required
              />
            </div>
            <div className="form-group">
              <label>Descrição</label>
              <textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                rows={3}
                placeholder="Opcional: contexto da pasta"
              />
            </div>
          </div>
          <div className="modal-actions">
            <button type="button" className="btn btn-danger" onClick={handleClose}>Cancelar</button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Criando...' : 'Criar Pasta'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NewFolderModal;
